export const ADS_CONFIG = 'ADS_CONFIG';
export const ADS_CONFIG_INVALIDATED = 'ADS_CONFIG_INVALIDATED';
export const ADS_INITIALIZED = 'ADS_INITIALIZED';
export const ADS_REFRESHED = 'ADS_REFRESHED';

export function initAdsConfig(id = '', tracking, query) {
    const pgn = ((tracking && tracking.context && tracking.context.PageName) || '').toLowerCase();
    const kvps = { pgtyp: id };

    // the adtar (or adprodtest) query param is used to test ads.
    // ?adprodtest=usuaptest01 will return test ad placeholders
    const adtar = query.adprodtest || query.adtar || null;

    if (pgn) kvps.pgn = pgn;
    if (adtar) kvps.adtar = adtar;

    const config = { level: `espn.com/watch/${id}`, kvps };
    return {
        type: ADS_CONFIG,
        id,
        config
    };
}

export function invalidateAdsConfig() {
    return {
        type: ADS_CONFIG_INVALIDATED
    };
}

export function adsInitialized() {
    return {
        type: ADS_INITIALIZED
    };
}

export function adsRefreshed() {
    return {
        type: ADS_REFRESHED
    };
}



// WEBPACK FOOTER //
// ./app/ads/actions/index.js